import { useEffect, useRef } from "react";
import { api } from "../api";
import { useLive } from "./live";

// Windows app only: silent printing to thermal printers through the desktop shell's bridge.
const KEY = "fyndine_printers";
export const desktop = () => (typeof window !== "undefined" ? window.fyndineDesktop : null);
export const getPrinters = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };
export const savePrinters = (p) => localStorage.setItem(KEY, JSON.stringify(p));

export async function silentPrint(kind, html) {
  const d = desktop(), p = getPrinters();
  const name = kind === "kot" ? p.kot_printer : p.bill_printer;
  if (!d || !name) return false;
  const r = await d.printSilent(html, name, Number(p.width) || 80);
  return !!r?.ok;
}

const PRINTED = "fyndine_printed_kots";
const loadPrinted = () => { try { return new Set(JSON.parse(localStorage.getItem(PRINTED)) || []); } catch { return new Set(); } };

// Kitchen/counter PC: prints every new KOT for this branch the moment it is sent from any device.
export function KotAutoPrinter({ branch, kotHtml }) {
  const printed = useRef(null);
  const busy = useRef(false);
  const enabled = !!desktop() && getPrinters().auto_kot && getPrinters().kot_printer;
  const run = async (first) => {
    if (!desktop() || !getPrinters().auto_kot || !getPrinters().kot_printer || !branch || busy.current) return;
    busy.current = true;
    if (!printed.current && !localStorage.getItem(PRINTED)) first = true;
    try {
      const { data } = await api.get(`/kots?branch=${branch}`);
      const set = printed.current || loadPrinted();
      for (const k of [...data].reverse()) {
        if (set.has(k.id)) continue;
        set.add(k.id);
        if (!first && Date.now() - new Date(k.printed_at).getTime() < 15 * 60000) await silentPrint("kot", kotHtml(k));
      }
      printed.current = set;
      localStorage.setItem(PRINTED, JSON.stringify([...set].slice(-500)));
    } catch { /* next event retries */ } finally { busy.current = false; }
  };
  useEffect(() => { run(true); }, [branch, enabled]); // eslint-disable-line
  useLive(() => run(false), ["tabs", "kots", "kds"]);
  return null;
}
